(function () {

    angular
        .module('app')
        .controller('TeacherProjectsController', TeacherProjectsController);

    TeacherProjectsController.$inject = [
        'authService',
        'projectsService', 'trainingService',
        '$mdDialog', '$scope', 'loggerService'
    ];

    function TeacherProjectsController(authService, projectsService, trainingService, $mdDialog, $scope, loggerService) {

        var vm = this;
        vm.authService = authService;

        $scope.submittingDeleteRequest = false;

        var alertId = 1;
        vm.errors = [];
        vm.warnings = [];
        vm.dismissAlert = function (type, errIdx) {
            vm[type].splice(errIdx, 1);
        };
        function displayAlert(type, status, errObj) {
            if (!errObj) {
                errObj = {};
            }
            var newId = alertId++;
            vm[type].push({
                alertid : newId,
                message : errObj.message || errObj.error || '未知错误',
                status : status
            });
            return newId;
        }


        vm.orderBy = 'name';

        vm.getProjectTypeLabel = function (project) {
            if (!project) {
                return '项目';
            }
            if (project.type === 'text') {
                return '文字识别项目';
            }
            if (project.type === 'imgtfjs') {
                return '图像识别项目';
            }
            if (project.type === 'numbers') {
                return '数字分类项目';
            }
            if (project.type === 'regression') {
                return '数值预测项目';
            }
            if (project.type === 'sounds') {
                return '声音识别项目';
            }
            if (project.type === 'language') {
                return '文字生成项目';
            }
            return project.type || '项目';
        };

        vm.getProjectTypeShort = function (project) {
            if (!project) {
                return '项';
            }
            if (project.type === 'text' || project.type === 'language') {
                return '文';
            }
            if (project.type === 'imgtfjs') {
                return '图';
            }
            if (project.type === 'numbers' || project.type === 'regression') {
                return '数';
            }
            if (project.type === 'sounds') {
                return '声';
            }
            return '项';
        };

        vm.getProjectTypeClass = function (project) {
            if (!project) {
                return 'supervisionIconBlue';
            }
            if (project.type === 'text' || project.type === 'language') {
                return 'supervisionIconBlue';
            }
            if (project.type === 'imgtfjs') {
                return 'supervisionIconTeal';
            }
            if (project.type === 'numbers' || project.type === 'regression') {
                return 'supervisionIconOrange';
            }
            if (project.type === 'sounds') {
                return 'supervisionIconPink';
            }
            return 'supervisionIconPurple';
        };



        function refreshProjectsList(profile) {
            loggerService.debug('[ml4ksupervise] refreshing projects list');

            projectsService.getClassProjects(profile)
                .then(function (projects) {
                    loggerService.debug('[ml4ksupervise] got projects list');

                    vm.projects = projects;

                    for (var i = 0; i < vm.projects.length; i++) {
                        var project = vm.projects[i];

                        var labels = project.labels || [];
                        if (project.type === 'sounds') {
                            labels = labels.filter(function (label) {
                                return label !== '_background_noise_';
                            });
                        }

                        if (labels.length > 0) {
                            var summary = '';
                            switch (labels.length) {
                                case 1:
                                    summary = labels[0];
                                    break;
                                case 2:
                                    summary = labels[0] + ' 或 ' + labels[1];
                                    break;
                                case 3:
                                    summary = labels[0] + ', ' +
                                              labels[1] + ' 或 ' +
                                              labels[2];
                                    break;
                                default:
                                    summary = labels[0] + ', ' +
                                              labels[1] + ' 或 ' +
                                              (labels.length - 2) + ' 个其他类别';
                                    break;
                            }
                            project.labelsSummary = summary;
                        }
                    }
                })
                .catch(function (err) {
                    loggerService.error('[ml4ksupervise] failed to get projects list', err);

                    displayAlert('errors', err.status, err.data);
                });
        }



        function refreshClassifiersList(profile) {
            loggerService.debug('[ml4ksupervise] refreshing classifiers list');

            trainingService.getUnmanagedClassifiers(profile.tenant)
                .then(function (classifiers) {
                    loggerService.debug('[ml4ksupervise] got classifiers list');

                    vm.classifiers = classifiers;
                })
                .catch(function (err) {
                    loggerService.debug('[ml4ksupervise] failed to get classifiers list');

                    if (err && err.status && err.status === 403) {
                        // probably a managed tenant - so they're not allowed
                        //  to review unmanaged classifiers (this is sorted
                        //  for them)
                    }
                    else {
                        loggerService.error(err);
                    }
                });
        }





        authService.getProfileDeferred()
            .then(function (profile) {
                vm.profile = profile;

                if (profile.role === 'supervisor') {
                    refreshProjectsList(profile);
                    refreshClassifiersList(profile);
                }
            })
            .catch(function (err) {
                displayAlert('errors', err.status, err.data);
            });


        vm.deleteModel = function (ev, project) {
            loggerService.debug('[ml4ksupervise] deleting model');

            var confirm = $mdDialog.confirm()
                .title('确认删除模型？')
                .textContent('要删除' +
                             (project.owner ? project.owner.username + ' 的' : '这个') +
                             '项目“' + project.name + '”里的机器学习模型吗？项目本身和训练数据会保留。')
                .ariaLabel('确认删除模型')
                .targetEvent(ev)
                .ok('删除模型')
                .cancel('取消');

            $mdDialog.show(confirm).then(
                function() {
                    loggerService.debug('[ml4ksupervise] submitting model deletion request');

                    project.hasModel = false;
                    trainingService.deleteModel(project, project.userid, project.classid, project.classifierId)
                        .then(function () {
                            loggerService.debug('[ml4ksupervise] model deletion successful');
                        })
                        .catch(function (err) {
                            loggerService.error('[ml4ksupervise] failed to delete model', err);

                            displayAlert('errors', err.status, err.data);
                        });
                },
                function() {
                    // cancelled. do nothing
                }
            );
        };

        vm.deleteClassifier = function (ev, classifier) {
            loggerService.debug('[ml4ksupervise] deleting classifier');

            $scope.submittingDeleteRequest = true;

            var confirm = $mdDialog.confirm()
                .title('确认删除未归档模型？')
                .textContent('要删除“' + classifier.name + '”吗？请确认它不是仍在使用的课程作品模型。')
                .ariaLabel('确认删除未归档模型')
                .targetEvent(ev)
                .ok('删除')
                .cancel('取消');

            $mdDialog.show(confirm).then(
                function() {
                    loggerService.debug('[ml4ksupervise] submitting classifier deletion request');

                    trainingService.deleteBluemixClassifier(vm.profile.tenant, classifier.id, classifier.credentials.id, classifier.type)
                        .then(function () {
                            loggerService.debug('[ml4ksupervise] classifier deletion successful');

                            $scope.submittingDeleteRequest = false;
                            vm.classifiers[classifier.type] = vm.classifiers[classifier.type].filter(function (c) {
                                return c.id !== classifier.id;
                            });
                        })
                        .catch(function (err) {
                            loggerService.error('[ml4ksupervise] failed to delete classifier', err);

                            $scope.submittingDeleteRequest = false;
                            displayAlert('errors', err.status, err.data);
                        });
                },
                function() {
                    // cancelled. do nothing
                }
            );
        };
    }
}());
